import * as React from 'react';

import { PageTemplateMenuStore } from './PageTemplateMenuStore';
import {
  PageTemplateMenuStoreContext,
  PageTemplateMenuStoreProvider
} from './context';

const usePageTemplateMenuStore = (): PageTemplateMenuStore => {
  const pageTemplateStoreContext = React.useContext(
    PageTemplateMenuStoreContext
  );

  return pageTemplateStoreContext.store as PageTemplateMenuStore;
};

export {
  usePageTemplateMenuStore,
  PageTemplateMenuStoreContext,
  PageTemplateMenuStoreProvider,
  PageTemplateMenuStore
};
